import store from "./store";

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Vue from "vue";
import i18n from "./lang";
import Notifications from 'vue-notification';
import VeeValidate from 'vee-validate';
import Echo from 'laravel-echo'
import storage from './storage'
import './components'
import VueAxios from 'vue-axios'
import axios from './plugins/axios';
import vClickOutside from 'v-click-outside'

require('./bootstrap');
const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)
window.Vue = require('vue');
window.io = require('socket.io-client');
// window.Echo = new Echo({
//  broadcaster: 'socket.io',
//  host: 'https://my.torontoimperial.com:6001',
//  auth: {
//   headers: {
//    // Authorization: 'Bearer ' + token
//   }
//  }
// });

if (process.env.MIX_HIDE_CHAT !== 'true') {
    let token = document.head.querySelector('meta[name="csrf-token"]');
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: window.location.hostname,
        auth: {
            headers: {
                Authorization: 'Bearer ' + token
            }
        }
    });
}

Vue.component('multiselect', Multiselect);
Vue.component('datetime', flatPickr);

Vue.filter("ddmmyy", function (value) {
    if (!value) return "";
    const date_value = new Date(value);
    return `${String(date_value.getDate()).padStart(2, '0')}.${String(date_value.getMonth() + 1).padStart(2, '0')}.${date_value.getFullYear()} ${String(date_value.getHours() + 1).padStart(2, '0')}:${date_value.getMinutes() < 10 ? "0" + date_value.getMinutes() : date_value.getMinutes()}`
});

export const bus = new Vue();

Vue.use(VueAxios, axios)
Vue.use(vClickOutside)
Vue.use(Notifications);
Vue.use(VeeValidate, {
    strict: true,
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});

const app = new Vue({
    name: 'app_client.js',

    el: '#app',

    i18n,

    store,

    components: {
        'student-update-profile-form': () => import('./components/Student/StudentUpdateProfileFormComponent' /* webpackChunkName: 'StudentUpdateProfileFormComponent' */),
        'notifications-list': () => import('./components/Student/NotificationsList' /* webpackChunkName: 'NotificationsListComponent' */),
    },

    data() {
        return {
            test: null,
            storage: storage,
            isChatShow: false,
            isNotificationModalShow: false,
            notificationsList: [],
            isLocaleInit: false,
            settingsArray:[],
        }
    },
    async mounted(){
        await this.getSettings();
        this.mbShowRotationModal();
        this.mbHideSidebar();
    },
    created() {
        this.$on('chatShow', payload => this.isChatShow = payload);
    },

    methods: {
        async toggleNotificationModalStatus() {
            this.isNotificationModalShow = this.isNotificationModalShow !== true;

            if(this.isNotificationModalShow) {
                await this.getNotifications()
            }
        },

        async getNotifications () {
            try {
                const { data } = await axios.get('/api/v1/student/notifications');
                this.notificationsList = data;
            } catch(e) {
                console.error(e)
            }
        },

        mbShowRotationModal(){
            console.log(this.settings)
            if (window.matchMedia("(orientation: portrait)").matches && window.innerWidth < 809.7){
                var url = new URL(window.location.href);
                var check_orientation = url.searchParams.get("check_orientation");
                if(this.settings.mobile_check_orientation == '1' && (check_orientation == 'true' || check_orientation == '1' || check_orientation === null)){
                    document.getElementsByClassName('y-portrait')[0].style.display = "flex";
                }
            }
        },

        mbHideSidebar(){
            if (this.settings.mobile_show_sidebar == '0' && (window.matchMedia("(orientation: portrait)").matches && window.innerWidth < 809.7)){
                if(document.getElementsByTagName('aside').length){
                    document.getElementsByTagName('aside')[0].style.display = "none";
                }
            }
        },

        closeNotificationModal() {
            this.isNotificationModalShow = false;
        },

        async initLocale() {
            if (!this.isLocaleInit) {
                try {
                    this.isLocaleInit = true;
                    const { data: { locale } } = await axios.get('/locale/language');
                    this.$i18n.locale = locale || (process.env.MIX_APP_LOCALE !== undefined ? process.env.MIX_APP_LOCALE : 'ua');
                } catch (error) {
                    console.log(error)
                }
            }
        },

        async setNotificationsAsRead() {
            try {
                const { status } = await axios.get('/api/v1/student/notifications/makeAsRead');

                if(status === 200) {
                    await this.getNotifications()
                }

            } catch(e) {
                console.error(e)
            }

            this.closeNotificationModal()

        },

        async getSettings() {
            const {status, data} = await axios.get('/admin/settings/get/bulk');
            if(status === 200) {
                this.settingsArray = data
            }
        }
    },
    computed:{
        settings(){
            let settings = {}
            this.settingsArray.forEach(el => {
                settings[el.key] = el.value
            });
            return settings
        }
    }
});

app.initLocale();
